/**
 * Convert a snake_case impact_metric_key to a Title Case readable label.
 * e.g. "revenue_generated" -> "Revenue Generated"
 */
export function formatMetricLabel(key: string): string {
  if (!key) return "";
  return key
    .split("_")
    .filter(Boolean)
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
    .join(" ");
}

/**
 * Format a value for display based on the question type.
 *   currency        -> "$X,XXX"
 *   number          -> integer string with thousands separators
 *   rating          -> "X / 5"
 *   text / choice   -> string as-is
 */
export function formatMetricValue(
  value: number | string | null,
  questionType: string
): string {
  if (value === null || value === undefined || value === "") return "—";

  switch (questionType) {
    case "currency": {
      const n = typeof value === "number" ? value : Number(value);
      if (Number.isNaN(n)) return String(value);
      return `$${n.toLocaleString(undefined, { maximumFractionDigits: 0 })}`;
    }
    case "number": {
      const n = typeof value === "number" ? value : Number(value);
      if (Number.isNaN(n)) return String(value);
      return Math.round(n).toLocaleString();
    }
    case "rating": {
      const n = typeof value === "number" ? value : Number(value);
      if (Number.isNaN(n)) return String(value);
      return `${n} / 5`;
    }
    case "multiple_choice":
    case "text":
    default:
      return String(value);
  }
}

/**
 * Returns direction + absolute delta for a numeric comparison.
 */
export function calcChangeIndicator(
  current: number,
  previous: number
): { direction: "up" | "down" | "none"; delta: number } {
  if (
    typeof current !== "number" ||
    typeof previous !== "number" ||
    Number.isNaN(current) ||
    Number.isNaN(previous)
  ) {
    return { direction: "none", delta: 0 };
  }
  const diff = current - previous;
  if (diff > 0) return { direction: "up", delta: Math.abs(diff) };
  if (diff < 0) return { direction: "down", delta: Math.abs(diff) };
  return { direction: "none", delta: 0 };
}
